<template>
	<div class="container">
		<div class="main_box">
			<!--导航-->
			<navBox :pageName="'Contact Us'"></navBox>
			<!--导航-->
			<!--banner-->
			<div
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
				class="banner_box"
			>
				<img src="../../assets/img_public/contact/banner01.webp" />
			</div>
			<!--banner-->
			<!--位置-->
			<div
				data-aos="fade-left"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
				class="location_box"
			>
				Home&ensp;/&ensp;<span>Contact Us</span>
			</div>
			<!--位置-->
			<!--块1-->
			<div
				data-aos="fade-up"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
				class="block_1"
			>
				<div class="msg_box">
					<div class="phone_box">
						<van-icon name="phone" size="30px" color="#C8000A" style="top: 4px;" />&nbsp;&nbsp;010-69390623
					</div>
					<div class="txt_box">
						<div class="txt_el">Abiores Technology Co.,Ltd.</div>
						<div class="txt_el">E-mail: <a href="mailto:Gene@CorDx.com">Gene@CorDx.com</a></div>
						<!-- <div class="txt_el">邮编：102433</div> -->
					</div>
					<div class="txt_box">
						<div class="txt_el">Add：9909 Huennekens St., Suite 205 San Diego, CA 92121</div>
					</div>
				</div>
				<div id="MapBox" class="map_box">
					<img src="../../assets/img_public/contact/map_en.webp" />
				</div>
			</div>
			<!--块1-->
			<!--块2-->
			<div class="block_2">
				<contact></contact>
			</div>
			<!--块2-->
			<!--版权-->
			<footerBox></footerBox>
			<!--版权-->
		</div>
		<!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading"><van-loading /></div>
		</transition>
		<!--loading-->
	</div>
</template>

<script>
import navBox from '@/component/pc/nav.vue'  //导航组件
import footerBox from '@/component/pc/footer.vue'  //版权组件
import contact from '@/component/pc/contact.vue'  //联系我们组件
// import AMapLoader from '@amap/amap-jsapi-loader';
export default {
	components:{
		navBox,
		footerBox,
		contact
	},
	data() {
		return {
			isLoading: true,  //界面loading
			mapList: [{ lnglats: [116.080849, 39.639883] }],
			loaction: [116.087849, 39.644883],
			map: null,
		}
	},
	created(){
		let that = this;
	},
	mounted() {
		let that = this;
		that.$nextTick(() => {
			// that.initMap();
			that.isLoading = false;
		});
	},
	watch: {
		//
	},
	methods: {
		//初始化地图
		// initMap() {
		// 	let that = this;
		// 	AMapLoader.load({
		// 		key:"1a79407995c8bc2abb2230330562814e",  // 申请好的Web端开发者Key，首次调用 load 时必填  c7422fb1c71586f2ab0e00eeeda9ea3e
		// 		version:"1.4.15",  // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
		// 		plugins:[''],  // 需要使用的的插件列表，如比例尺'AMap.Scale'等
		// 	}).then((AMap)=>{
		// 		that.map = new AMap.Map("MapBox",{  //设置地图容器id
		// 			viewMode:"3D",    //是否为3D地图模式
		// 			zoom: 0,           //初始化地图级别
		// 			mapStyle: 'amap://styles/macaron',
		// 			center: that.loaction, //初始化地图中心点位置640419
		// 			lang: 'en'
		// 		});
		// 		that.setMapMarker();
		// 		that.map.setZoom(10);
		// 		// normal （标准）、dark（幻影黑）、light（ 月光银）、whitesmoke（远山黛）、fresh（草色青）、grey（雅士灰）、graffiti（涂鸦）、macaron（马卡龙）、blue（靛青蓝）、darkblue（极夜蓝）、wine（酱籽）
		// 	}).catch(e=>{
		// 		console.log(e);
		// 	});
		// },
		// setMapMarker () {
		// 	let that = this;
		// 	// 创建 AMap.Icon 实例
		// 	let icon = new AMap.Icon({
		// 		size: new AMap.Size(36, 36), // 图标尺寸
		// 		image: "//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-red.png", // Icon的图像
		// 		imageSize: new AMap.Size(24, 30), // 根据所设置的大小拉伸或压缩图片
		// 		imageOffset: new AMap.Pixel(0, 0)  // 图像相对展示区域的偏移量，适于雪碧图等
		// 	});
		// 	let makerList = []
		// 	that.mapList.forEach((item) => {
		// 		// 遍历生成多个标记点
		// 		let marker = new AMap.Marker({
		// 			map: that.map,
		// 			zIndex: 9999999,
		// 			icon: icon, // 添加 Icon 实例
		// 			offset: new AMap.Pixel(0, 0), //icon中心点的偏移量
		// 			position: item.lnglats // 经纬度对象new AMap.LngLat(x, y)，也可以是经纬度构成的一维数组[116.39, 39.9]
		// 		});
		// 		makerList.push(marker)
		// 	});
		// 	that.map.add(makerList)
		//     that.map.setFitView();
		// },
	}
}
</script>

<style lang="less" scoped>
.main_box{
	color: #333333;
	//块2
	.block_2{
		width: 1200px;
		margin: 120px auto;
	}
	//块1
	.block_1{
		width: 1200px;
		margin: 0 auto;
		.map_box{
			width: 100%;
			// height: 400px;
			margin-top: 60px;
			img{
				width: 100%;
			}
		}
		.msg_box{
			.txt_box{
				margin-top: 14px;
				.txt_el{
					display: inline-block;
					margin-right: 100px;
					font-size: 18px;
					a{
						font-size: 18px;
						color: #333333;
					}
				}
			}
			.phone_box{
				display: inline-block;
				margin-bottom: 10px;
				padding-bottom: 10px;
				font-size: 32px;
				border-bottom: 1px solid #C8000A;
			}
		}
	}
	//位置
	.location_box{
		width: 1200px;
		margin: 0 auto;
		padding: 40px 0 80px 0;
		span{
			color: #999999;
		}
	}
	//banner
	.banner_box{
		img{
			width: 100%;
			min-width: 1200px;
		}
	}
}
</style>